import { getAllowedDomains } from "@utils/EmailUtils";
import { Button, Col, Form, Input, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { OnBoarding } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { api, getPasswordApi } from "~/Services";

const { Title } = Typography;

const allowedDomains = getAllowedDomains();

export const GetLoginPassword = () => {
  const [email, setEmail] = useState("");
  const [hasBlurred, setHasBlurred] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { openToast } = useNotification();
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();

  const validateEmail = (value: string): string => {
    if (!value.trim()) {
      return "Email is required";
    }

    const isValidDomain = allowedDomains.some((domain) => value.toLowerCase().endsWith(domain));

    return isValidDomain ? "" : `Email must end with ${allowedDomains.join(" or ")}`;
  };

  useEffect(() => {
    const message = validateEmail(email);
    setIsValid(message === "");
  }, [email]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    setErrorMessage("");
  };

  const handleBlur = () => {
    setHasBlurred(true);
    const message = validateEmail(email);
    setErrorMessage(message);
  };

  const handleSubmit = () => {
    const message = validateEmail(email);
    setErrorMessage(message);
    setIsLoading(true);
    if (!message) {
      getPasswordApi
        .post(`/auth/setup-password?emailAddress=${email}`)
        .then((res) => {
          const message = res?.data?.message;
          openToast({ content: message, type: "success" });
          navigate("/auth/login");
        })
        .catch((err) => {
          const message = err?.response?.data?.message;
          openToast({ content: message, type: "error" });
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <OnBoarding>
      <Title level={2}>Get Password</Title>
      <Row gutter={[0, 16]}>
        <Col span={24}>
          <Form layout="vertical">
            <Form.Item
              label="Email"
              validateStatus={hasBlurred && errorMessage ? "error" : ""}
              help={hasBlurred && errorMessage ? errorMessage : ""}
            >
              <Input
                placeholder="Enter your email"
                value={email}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={isLoading}
                type="primary"
                onClick={handleSubmit}
                disabled={!isValid}
                size="large"
                block
                style={{ marginTop: 20 }}
              >
                Get Password
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </OnBoarding>
  );
};
